import "./PreguntasTalles.css";

export const PreguntasTallesTops = () => {
  const tops = [
    {
      icon: "A",
      name: "Ancho de hombro",
      S: "8 cm",
      M: "12 cm",
      L: "13 cm",
    },
    {
      icon: "B",
      name: "Contorno de pecho",
      S: "72 cm",
      M: "82 cm",
      L: "92 cm",
    },
    {
      icon: "C",
      name: "Contorno de cintura",
      S: "68 cm",
      M: "78 cm",
      L: "88 cm",
    },
    {
      icon: "D",
      name: "Contorno de cadera",
      S: "-",
      M: "-",
      L: "-",
    },
    {
      icon: "E",
      name: "Largo de manga",
      S: "-",
      M: "-",
      L: "-",
    },
    {
      icon: "F",
      name: "Largo de talle",
      S: "43 cm",
      M: "46 cm",
      L: "49 cm",
    },
  ];

  return (
    <table className="preguntas-item-content-talles">
      <thead>
        <tr>
          <th>Tabla de talles</th>
          <th>Talle S</th>
          <th>Talle M</th>
          <th>Talle L</th>
        </tr>
      </thead>
      <tbody>
        {tops.map((file, index) => (
          <tr key={index}>
            <th>
              <div>
                <span>{file.icon}</span>
              </div>
              {file.name}
            </th>
            <td>{file.S}</td>
            <td>{file.M}</td>
            <td>{file.L}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
